module.exports = __webpack_public_path__ + "img/amazon.548e61a2.png";